import payment from './CN/payment';




export default {
  ...payment
};
